export interface ProcedureItem {
    id: number;
    category: number;
    title: string;
    truncatedDescription: string;
}

export interface ProcedureDetails {
    id: number;
    lastUpdatedUtc: string;
    title: string;
    description: string;
    comments: string;
    filePath: string;
    category: string;
    score: number;
}

export interface ProceduresResponse {
    procedures: ProcedureItem[];
}

// Category constants for easier reference
export const PROCEDURE_CATEGORIES = {
    CLEANING: 1,
    PREWASH: 2,
    OPERATIONAL: 3,
    EMERGENCY: 4,
    SAMPLING: 5,
    WALLWASH: 6,
    CHARTERER: 7,
} as const;